import React, { useState, useEffect, useMemo } from 'react';
import './TextEffect.css';

const TextEffect = () => {
  const words = useMemo(
    () => ['éducative', 'divertissante', 'innovante', 'interactive', 'ludique'],
    []
  );
  const colors = useMemo(
    () => ['#FF5733', '#33FF57', '#3357FF', '#FF33A1', '#F3FF33'],
    []
  );

  const [currentWord, setCurrentWord] = useState(words[0]);
  const [wordsList, setWordsList] = useState(words.slice(1));
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const [charIndex, setCharIndex] = useState(0);
  const [currentColor, setCurrentColor] = useState(colors[0]);

  // Calculer la largeur minimale pour le texte animé
  const maxWordWidth = useMemo(() => {
    const longestWord = words.reduce((a, b) => (a.length > b.length ? a : b));
    return longestWord.length * 14; // Approximation en px
  }, [words]);

  useEffect(() => {
    if (wordsList.length === 0) {
      setWordsList(words);
    }
  }, [wordsList, words]);

  useEffect(() => {
    if (!currentWord) return;

    let interval = null;
    if (isTyping) {
      interval = setInterval(() => {
        if (charIndex < currentWord.length) {
          setDisplayedText((prev) => prev + currentWord[charIndex]);
          setCharIndex((prev) => prev + 1);
        } else {
          clearInterval(interval);
          setTimeout(() => setIsTyping(false), 2000);
        }
      }, 200);
    } else {
      interval = setInterval(() => {
        if (charIndex > 0) {
          setDisplayedText((prev) => prev.slice(0, -1));
          setCharIndex((prev) => prev - 1);
        } else {
          clearInterval(interval);
          const randomIndex = Math.floor(Math.random() * wordsList.length);
          const newWord = wordsList[randomIndex];
          setCurrentWord(newWord);
          setCurrentColor(colors[words.indexOf(newWord)]);
          setWordsList((prev) => prev.filter((word) => word !== newWord));
          setIsTyping(true);
          setCharIndex(0);
          setDisplayedText('');
        }
      }, 100);
    }

    return () => clearInterval(interval);
  }, [currentWord, isTyping, charIndex, wordsList, colors, words]);

  return (
    <div className="welcome-container">
      <h1>
        <span className="static-text">
          Bienvenue sur{' '}
          <span className="dwag-text">
            <span className="letter-d">D</span>
            <span className="letter-w">W</span>
            <span className="letter-a">A</span>
            <span className="letter-g">G</span>
          </span>
          ,
          <br />
          une application{' '}
        </span>
        <span
          className="changing-text"
          style={{ color: currentColor, minWidth: `${maxWordWidth}px` }}
        >
          {displayedText}
        </span>
      </h1>
    </div>
  );
};

export default TextEffect;